import React from 'react'

import { PlatformBoxProps } from './types'
import { PlatformBoxStyled, PlatformBoxTitleStyled, PlatformBoxContentStyled, PlatformBoxButtonsStyled } from './styles'
import Button from '../../atoms/Button'

const PlatformBox: React.FC<PlatformBoxProps> = ({ head, platforms }) => (
  <PlatformBoxStyled>
    <PlatformBoxTitleStyled as="p" variant="bodyMontserrat11">
      {head}
    </PlatformBoxTitleStyled>
    <PlatformBoxContentStyled>
      {platforms.map((item) => (
        <PlatformBoxButtonsStyled key={item.label}>
          <Button url={item.url} urlText={item.urlText} urlIsExternal={true} variant="withIcon" label={item.label} caption={item.caption} />
        </PlatformBoxButtonsStyled>
      ))}
    </PlatformBoxContentStyled>
  </PlatformBoxStyled>
)

export default PlatformBox
